import React from "react";
import FootballGameConfig from "./FootballGameConfig";
import HorseRacingConfig from "./HorseRacingConfig";
import EightBallConfig from "./EightBallConfig";
import PlinkoConfig from "./PlinkoConfig";
import SkullIslandConfig from "./SkullIslandConfig";
import GolfConfig from "./GolfConfig";
import RoadkillConfig from "./RoadkillConfig";
import MastersConfig from "./MastersConfig";

export { FootballGameConfig, HorseRacingConfig, EightBallConfig };

export const GAME_TYPES = {
  DEFAULT: 0,
  PUCK_RACING: 1,
  FOOTBALL: 2,
  HORSE_RACING: 3,
  PLINKO: 4,
  SKULL_ISLAND: 5,
  BALL_POOL: 6,
  GOLF: 7,
  ROADKILL: 8,
  MASTERS: 9,
};

export const getGameConfigComponent = (gameType, props) => {
  switch (gameType) {
    case GAME_TYPES.FOOTBALL:
      return <FootballGameConfig {...props} />;
    case GAME_TYPES.HORSE_RACING:
      return <HorseRacingConfig {...props} />;
    case GAME_TYPES.PUCK_RACING:
      return <EightBallConfig {...props} />;
    case GAME_TYPES.PLINKO:
      return <PlinkoConfig {...props} />;
    case GAME_TYPES.GOLF:
      return <GolfConfig {...props} />;
    case GAME_TYPES.SKULL_ISLAND:
      return <SkullIslandConfig {...props} />;
    case GAME_TYPES.ROADKILL:
      return <RoadkillConfig {...props} />;
    case GAME_TYPES.MASTERS:
      return <MastersConfig {...props} />;
    case GAME_TYPES.DEFAULT:
    default:
      return <EightBallConfig {...props} />; // Default to Puck Racing config
  }
};
